<template>
  <StepContainer v-loading="isLoading" title="اطلاعات برنامه">
    <AppInfoForm v-model="appInfo" :errors="fieldErrors" />

    <StepControllers slot="actions" @change-step="goToStep" />
  </StepContainer>
</template>

<script>
import StepContainer from '../common/StepContainer';
import AppInfoForm from './AppInfoForm';
import StepControllers from '../common/StepControllers';
import { mapActions, mapGetters } from 'vuex';
import { CHANGE_DRAFT_APP_STATE, DRAFT_APP } from '@/store/types';

export default {
  name: 'AppInfoStep',
  components: { StepContainer, AppInfoForm, StepControllers },
  inject: ['stepperController'],
  data() {
    return {
      isLoading: false,
      fieldErrors: {},
      appInfo: {
        nameFa: '',
        nameEn: '',
        shortDescriptionFa: '',
        shortDescriptionEn: '',
        descriptionFa: '',
        descriptionEn: '',
      },
    };
  },
  computed: {
    ...mapGetters({ draftApp: DRAFT_APP }),
  },
  watch: {
    draftApp: {
      immediate: true,
      handler(draftApp) {
        this.appInfo = {
          nameFa: draftApp.nameFa,
          nameEn: draftApp.nameEn,
          shortDescriptionFa: draftApp.shortDescriptionFa,
          shortDescriptionEn: draftApp.shortDescriptionEn,
          descriptionFa: draftApp.descriptionFa,
          descriptionEn: draftApp.descriptionEn,
        };
      },
    },
  },
  created() {
    this.stepperController.onStepClick(this.goToStep);
  },
  beforeDestroy() {
    this.stepperController.removeOnStepClick(this.goToStep);
  },
  methods: {
    ...mapActions({ checkAndChangeStep: CHANGE_DRAFT_APP_STATE }),

    goToStep(step) {
      this.isLoading = true;
      this.fieldErrors = {};

      this.checkAndChangeStep({ to: step, data: this.appInfo })
        .catch(({ message, errors = [], fieldErrors = {} }) => {
          this.$message.error(message);
          this.errors = errors;
          this.fieldErrors = fieldErrors;
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
